// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1FRs5","row":"ProcedureTreatmentSummary_row__SUtql"};